export const TimerWrapper = `inline-flex flex-row items-center font-GoodPro-Wide font-medium tracking-normal text-center relative`

export const TimerBlock = `inline-flex flex-col text-28 mr-2.5 last-of-type:mr-0 w-10 leading-40`

export const TimerInfo = `uppercase text-10 font-GoodPro font-medium tracking-1 text-center`
